import { types } from 'mobx-state-tree';
const ConfirmDialogModel = types.model({
    open: types.boolean,
    title: types.string,
    message: types.string,
    confirmButtonLabel: types.string,
    cancelButtonLabel: types.string,
}).actions((self) => {
    let confirmHandler;
    let cancelHandler;
    function showConfirm(title, message, newConfirmHandler, newCancelHandler = undefined, confirmButtonLabel = 'OK', cancelButtonLabel = 'Cancel') {
        self.title = title;
        self.message = message;
        self.open = true;
        self.confirmButtonLabel = confirmButtonLabel;
        self.cancelButtonLabel = cancelButtonLabel;
        confirmHandler = newConfirmHandler;
        cancelHandler = newCancelHandler;
    }
    function cancel() {
        if (cancelHandler) {
            cancelHandler();
        }
        self.open = false;
    }
    function confirm() {
        if (confirmHandler) {
            confirmHandler();
        }
        self.open = false;
    }
    return {
        showConfirm,
        confirm,
        cancel,
    };
});
export default ConfirmDialogModel;
//# sourceMappingURL=ConfirmDialogModel.js.map